function runHmReadyQueue() {
    var queue = window.hmReadyQueue || [];
    window.hmReadyQueue = [];
    for (var i = 0; i < queue.length; i++) {
        if (typeof queue[i] === "function") {
            queue[i](jQuery);
        }
    }
}

if (typeof jQuery !== "undefined") {
    window.hmReady = function(callback) {
        jQuery(function() {
            callback(jQuery);
        });
    };
    jQuery(runHmReadyQueue);
}

(function($) {
    $(function() {

    $('.flexible-content > section.grid table, .flexible-content > section.text table').each(function() {
        var table = $(this);
        if (!table.closest('.table-responsive').length) {
            table.wrap('<div class="table-responsive" tabindex="0"></div>');
        }
    });

    function deferSlickInit() {
        if (!$.fn.slick || $.fn.slick._hmDeferred) {
            return;
        }

        var originalSlick = $.fn.slick;
        var immediateSelectors = [
            '.home-slideshow',
            '.collection-slider-4items',
            '.promo-slider-1items',
            '.topBar-slider-style1',
            '.infobar-slider-4items',
            '.product-thumb-horizontal',
            '.product-thumb-vertical',
            '.productSlider',
            '.productSlider-style2'
        ].join(',');

        function run($slider, args) {
            if ($slider.hasClass('slick-initialized')) {
                return;
            }

            originalSlick.apply($slider, args);
        }

        $.fn.slick = function() {
            var args = arguments;
            var firstArg = args[0];

            if (typeof firstArg === 'string') {
                return originalSlick.apply(this, args);
            }

            this.each(function() {
                var element = this;
                var $slider = $(element);

                if ($slider.is(immediateSelectors) || $slider.closest(immediateSelectors).length) {
                    run($slider, args);
                    return;
                }

                if (element._hmSlickInitQueued) {
                    return;
                }

                element._hmSlickInitQueued = true;

                if ('IntersectionObserver' in window) {
                    var observer = new IntersectionObserver(function(entries) {
                        entries.forEach(function(entry) {
                            if (entry.isIntersecting) {
                                observer.unobserve(element);
                                run($slider, args);
                            }
                        });
                    }, {
                        rootMargin: '700px 0px'
                    });

                    observer.observe(element);
                    return;
                }

                window.setTimeout(function() {
                    run($slider, args);
                }, 250);
            });

            return this;
        };

        $.fn.slick._hmDeferred = true;
        $.fn.slick._hmOriginal = originalSlick;
    }

    deferSlickInit();

    var requestFrame = window.requestAnimationFrame || function(callback) {
        return window.setTimeout(callback, 16);
    };

    function getWindowWidth() {
        return window.innerWidth || document.documentElement.clientWidth || 0;
    }

    function getScrollTop() {
        return window.pageYOffset || document.documentElement.scrollTop || 0;
    }

    function bindStickyNav(nav) {
        if (!nav.length) {
            return;
        }

        var element = nav[0],
                offsetTop = element.getBoundingClientRect().top + getScrollTop(),
                headerHeight = element.offsetHeight,
                injectSpace = $("<div />", {height: headerHeight}).insertAfter(nav);
        var fixedState = null,
                smallState = null,
                ticking = false;

        injectSpace.hide();

        function update() {
            var scrollTop = getScrollTop(),
                    nextFixed = scrollTop > offsetTop,
                    nextSmall = scrollTop > 150;

            if (nextFixed !== fixedState) {
                nav.toggleClass("is-fixed", nextFixed);
                injectSpace.toggle(nextFixed);
                fixedState = nextFixed;
            }

            if (nextSmall !== smallState) {
                nav.toggleClass("is-small animated fadeIn", nextSmall);
                smallState = nextSmall;
            }
        }

        function scheduleUpdate() {
            if (ticking) {
                return;
            }

            ticking = true;
            requestFrame(function() {
                ticking = false;
                update();
            });
        }

        $(window).on("load scroll", scheduleUpdate);
        update();
    }

    function withBootstrap(callback) {
        if (window.bootstrap) {
            callback();
            return;
        }

        if (window.hmLoadBootstrap) {
            window.hmLoadBootstrap(callback);
        }
    }

    /*-----------------------------------------
     01. Preloader Loading
     -----------------------------------------*/
    function pre_loader() {
        $("#load").fadeOut();
        $('#pre-loader').delay(500).fadeOut(500);
    }
    pre_loader();

    function dismiss() {
        $(".product-notification .close").on('click', function() {
            $(".product-notification").hide().fadeOut('slow');
        });
    }
    dismiss();

    /*-----------------------------------------
     02. Sticky Header
     -----------------------------------------*/
    function sticky_header() {
        if ($(".header").hasClass("header-fixed")) {
            var nav = $(".header");
            bindStickyNav(nav);
        }
    }
    sticky_header();

    /*-----------------------------------------
     02. Sticky Header
     -----------------------------------------*/
    function sticky_menu_header() {
        if (getWindowWidth() > 992) {
            if ($(".main-menu-outer").hasClass("header-fixed")) {
                var nav = $(".main-menu-outer");
                bindStickyNav(nav);
            }
        }
    }
    sticky_menu_header();

    /*-----------------------------------------
     03. Mobile Main Menu
     -----------------------------------------*/
    var selectors = {
        body: 'body',
        sitenav: '#siteNav',
        navLinks: '#siteNav .lvl1 > a',
        menuToggle: '.js-mobile-nav-toggle',
        mobilenav: '.mobile-nav-wrapper',
        menuLinks: '#MobileNav a > .anm-angle-down-l, #MobileNav a > .anm-angle-up-l',
        closemenu: '.closemobileMenu'
    };

    $(selectors.navLinks).each(function() {
        if ($(this).attr('href') == window.location.pathname)
            $(this).addClass('active');
    });

    function setMobileMenu(open) {
        $(selectors.mobilenav).toggleClass('active', open);
        $(selectors.body).toggleClass('menuOn', open);
        $(selectors.menuToggle)
            .toggleClass('mobile-nav--close', open)
            .toggleClass('mobile-nav--open', !open)
            .attr('aria-expanded', open);
    }

    $(selectors.menuToggle).on('click', function() {
        setMobileMenu(!$(selectors.mobilenav).hasClass('active'));
    });

    $(selectors.closemenu).on('click', function() {
        setMobileMenu(false);
    });

    $('body').on('click', function(event) {
        if (!$(event.target).closest(selectors.mobilenav + ', ' + selectors.menuToggle).length) {
            setMobileMenu(false);
        }
    });

    $(selectors.menuLinks).on('click', function(e) {
        e.preventDefault();
        $(this).toggleClass('anm-angle-down-l anm-angle-up-l');
        $(this).parent().next().slideToggle();
    });

    function desktop_megamenu_click() {
        var itemSelector = '#siteNav > li.lvl1.parent.megamenu';
        var toggleSelector = itemSelector + ' > a.js-megamenu-toggle';

        function closeMegamenu() {
            $(itemSelector)
                    .removeClass('is-open')
                    .children('a.js-megamenu-toggle')
                    .attr('aria-expanded', 'false');
        }

        $(document).on('click', toggleSelector, function(e) {
            if (getWindowWidth() < 990) {
                return;
            }

            e.preventDefault();

            var $link = $(this);
            var $item = $link.parent(itemSelector);
            var shouldOpen = !$item.hasClass('is-open');

            closeMegamenu();

            if (shouldOpen) {
                $item.addClass('is-open');
                $link.attr('aria-expanded', 'true');
            }
        });

        $(document).on('click', function(e) {
            if (!$(e.target).closest(itemSelector).length) {
                closeMegamenu();
            }
        });

        $(document).on('keydown', function(e) {
            if (e.key === 'Escape' || e.keyCode === 27) {
                closeMegamenu();
            }
        });

        $(window).on('resize', function() {
            if (getWindowWidth() < 990) {
                closeMegamenu();
            }
        });
    }
    desktop_megamenu_click();


    /*--------------------------------------
     04. Vertical Categories Menu
     -------------------------------------- */
    $(".header-vertical-menu .menu-title").on("click", function(event) {
        $(".header-vertical-menu .vertical-menu-content").slideToggle(300);
        $(this).toggleClass('active');
    });

    // More Categories Open/Close
    $('.moreSlideOpen').slideUp();
    $('.moreCategories').on('click', function() {
        $(this).toggleClass('show');
        $('.moreSlideOpen').slideToggle();
    });


    /*-----------------------------------------
     05. Setting Box dropdown
     -----------------------------------------*/
    function setting_box() {
        $(".setting-link").on("click", function() {
            $("#settingsBox").toggleClass("active");
        });
        $("body").on("click", function(e) {
            var t = $(e.target);
            t.parents().is("#settingsBox") || t.parents().is(".setting-link") || t.is(".setting-link") || $("#settingsBox").removeClass("active");
        });
    }
    setting_box();

    /* Account dropdown */
    function account_links() {
        $(".account-link").on("click", function() {
            $("#accountBox").toggleClass("active");
        });
        $("body").on("click", function(e) {
            var t = $(e.target);
            t.parents().is("#accountBox") || t.parents().is(".account-link") || t.is(".account-link") || $("#accountBox").removeClass("active");
        });
    }
    account_links();

    /* Top Links Show/Hide dropdown Mobile */
    function usermenu_dropdown() {
        $(".user-menu").on("click", function() {
            $(".user-links").toggleClass("active");
        });
        $("body").on("click", function(e) {
            var t = $(e.target);
            t.parents().is(".user-links") || t.parents().is(".user-menu") || t.is(".user-menu") || $(".user-links").removeClass("active");
        });
    }
    usermenu_dropdown();


    /*----------------------------------
     06. Language Picker
     -----------------------------------*/
    function language_picker() {
        $(".language-picker .default-option").click(function() {
            $(this).parent().toggleClass("active");
        });
        $(".language-picker .select-ul li").click(function() {
            var currentele = $(this).html();
            $(".language-picker .default-option li").html(currentele);
            $(this).parents(".language-picker").removeClass("active");
        });
        $("body").on("click", function(e) {
            var t = $(e.target);
            t.parents().is(".language-picker") || $(".language-picker").removeClass("active");
        });
    }
    language_picker();


    /*----------------------------------
     07. Currency Picker
     -----------------------------------*/
    function currency_picker() {
        $(".currency-picker .default-option").click(function() {
            $(this).parent().toggleClass("active");
        });
        $(".currency-picker .select-ul li").click(function() {
            var currentele = $(this).html();
            $(".currency-picker .default-option li").html(currentele);
            $(this).parents(".currency-picker").removeClass("active");
        });
        $("body").on("click", function(e) {
            var t = $(e.target);
            t.parents().is(".currency-picker") || $(".currency-picker").removeClass("active");
        });
    }
    currency_picker();


    /*----------------------------------
     08. Quantity Plus Minus
     -----------------------------------*/
    function qnt_incre() {
        $(".qtyBtn").on("click", function(e) {
            e.preventDefault();
            var qtyField = $(this).parent(".qtyField"),
                    input = $(qtyField).find(".qty")[0],
                    oldValue = input ? Number(input.value) : 0,
                    newVal = 1;

            if (!input || input.readOnly || input.disabled || $(this).attr('aria-disabled') === 'true') {
                return;
            }

            if ($(this).is(".plus")) {
                newVal = parseInt(oldValue) + 1;
            } else {
                newVal = parseInt(oldValue) - 1;
            }
            input.value = newVal;
            hmClampQuantityInput(input);
            if (Number(input.value) !== oldValue) {
                $(input).trigger('change');
            }
        });
    }
    qnt_incre();


    /*-------------------------------
     09. Timer Count Down
     ----------------------------------*/
    function skPlural(n, one, few, many) {
        if (n === 1) return one;
        if (n >= 2 && n <= 4) return few;
        return many;
    }

    if ($.fn.countdown) {
        $('[data-countdown]').each(function() {
            var $this = $(this), finalDate = $(this).data('countdown');
            $this.countdown(finalDate, function(event) {
                var d = event.offset.totalDays;
                var h = event.offset.hours;
                var m = event.offset.minutes;
                var s = event.offset.seconds;
                var dayText    = skPlural(d, lang.day_one,    lang.day_few,    lang.day_many);
                var hourText   = skPlural(h, lang.hour_one,   lang.hour_few,   lang.hour_many);
                var minuteText = skPlural(m, lang.minute_one, lang.minute_few, lang.minute_many);
                var secondText = skPlural(s, lang.second_one, lang.second_few, lang.second_many);
                $this.html(
                    "<span class='ht-count days'><span class='count-inner'><span class='time-count'>" + d + "</span> <span class='text'>" + dayText + "</span></span></span>" +
                    "<span class='ht-count hour'><span class='count-inner'><span class='time-count'>" + h + "</span> <span class='text'>" + hourText + "</span></span></span>" +
                    "<span class='ht-count minutes'><span class='count-inner'><span class='time-count'>" + m + "</span> <span class='text'>" + minuteText + "</span></span></span>" +
                    "<span class='ht-count second'><span class='count-inner'><span class='time-count'>" + s + "</span> <span class='text'>" + secondText + "</span></span></span>"
                );
            });
        });
    }
 
    /*-----------------------------------
     10. Color Swacthes
     -------------------------------------*/
 
    function img_swacthes() {
        var selector = '.variants-clr li';
        $(selector).on('click', function() {
            if(!$(this).hasClass('soldout')){
                $(this).addClass('active');
                $(this).siblings().removeClass('active');
            }
        });
    }
    img_swacthes();

    function size_swacthes() {
        var selector = '.variants-size li';
        $(selector).on('click', function() {
            if(!$(this).hasClass('soldout')){
                $(this).addClass('active');
                $(this).siblings().removeClass('active');
            }
        });
    }
    size_swacthes();


    /*-------------------------------
     11. Show hide Product Tags
     ----------------------------------*/
    $(".product-tags li").eq(4).nextAll().hide();
    $('.btnview').on('click', function() {
        $(".product-tags li").not('.filter-active').show();
        $(this).hide();
    });

    /* Show more and show less */
    $('.morelist').each(function() {
        var LiN = $(this).find('.more-item').length;
        if (LiN > 3) {
            $('.more-item', this).eq(2).nextAll().hide().addClass('toggleable');
            $(this).append('<li class="more">' + $(this).data('more') + '</li>');
        }
    });
    $('.morelist').on('click', '.more', function() {
        var wrapper = $(this).closest('.morelist');
        if ($(this).hasClass('less')) {
            $(this).text(wrapper.data('more')).removeClass('less');
        } else {
            $(this).text(wrapper.data('less')).addClass('less');
        }
        $(this).siblings('li.toggleable').slideToggle();
    });


    /*-------------------------------
     12. Show hide Product Filters
     ----------------------------------*/
    function setProductFilters(open) {
        $('.filterbar').toggleClass('active', open);
        $('body').toggleClass('filterOn', open);
        $('.btn-filter').attr('aria-expanded', open);
    }

    $('.btn-filter').on('click', function() {
        setProductFilters(!$('.filterbar').hasClass('active'));
    });

    $('.closeFilter').on('click', function() {
        setProductFilters(false);
    });

    $('body').on('click', function(event) {
        if (!$(event.target).closest('.filterbar, .btn-filter').length) {
            setProductFilters(false);
        }
    });

    $(document).on('keydown', function(event) {
        if (event.key !== 'Escape') {
            return;
        }
        if ($(selectors.mobilenav).hasClass('active')) {
            setMobileMenu(false);
            $(selectors.menuToggle).trigger('focus');
        }
        if ($('.filterbar').hasClass('active')) {
            setProductFilters(false);
            $('.btn-filter').trigger('focus');
        }
    });

    $(window).on('resize', function() {
        if (getWindowWidth() >= 992) {
            setMobileMenu(false);
            setProductFilters(false);
        }
    });


    /*-----------------------------------------
     13. Slick Slider
     -----------------------------------------*/
    /* 13.1 Homepage Slideshow */
    if($('.home-slideshow').length){
        $('.home-slideshow').slick({
            dots: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 7000,
            lazyLoad: 'ondemand'
        });
    }
 

    /* 13.2 Promobar Slider 1 Items */
    if($('.promo-slider-1items').length){
        $('.promo-slider-1items').slick({
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 4000,
            fade: true,
            cssEase: 'linear'
        }); 
    }

    /* 13.3 Top Bar Slider */
    if($('.infobar-slider-4items').length) {
        $('.infobar-slider-4items').slick({
            dots: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 4000,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    } 

    if($('.topBar-slider-style1').length){
        $('.topBar-slider-style1').slick({
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 4000,
            fade: true
        });
    } 

    /* 13.4 Sidebar Product */
    if($('.weekly-product').length){
        $('.weekly-product').slick({
            dots: false,
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 2500
        });
    }

    /* 13.5 Sidebar Product */
    if($('.sideProSlider').length){
        $('.sideProSlider').slick({
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            autoplay: true,
            autoplaySpeed: 4000
        });
    } 

    /* 13.6 Category Image 3 Items */
    if($('.category-image-3items').length){
        $('.category-image-3items').slick({
            dots: true,
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            autoplay: true,
            autoplaySpeed: 4000,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    } 

    /* 13.7 Collection Slider 3 Items */
    if($('.collection-slider-3items').length){
        $('.collection-slider-3items').slick({
            dots: true,
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 4000,
            arrows: false,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    } 

    if($('.image-text-slider3items').length){
        $('.image-text-slider3items').slick({
            dots: false,
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            responsive: [
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    } 

    /* 13.8 Collection Slider 4 Items */
    if($('.collection-slider-4items').length){
        $('.collection-slider-4items').slick({
            dots: false,
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            autoplay: true,
            autoplaySpeed: 4000,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    } 

    /* 13.9 Collection Slider 5 Items */
    if($('.collection-slider-5items').length){
        $('.collection-slider-5items').slick({
            dots: false,
            infinite: true,
            slidesToShow: 5,
            slidesToScroll: 1,
            arrows: true,
            autoplay: true,
            autoplaySpeed: 4000,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    } 

    /* 13.10 Collection Slider 6 Items */
    if( $('.collection-slider-6items').length){
        $('.collection-slider-6items').slick({
            dots: false,
            infinite: true,
            slidesToShow: 7,
            slidesToScroll: 1,
            arrows: true,
            autoplay: true,
            autoplaySpeed: 4000,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    } 

    /* 13.11 Collection Slider 8 Items */
    if($('.collection-slider-8items').length){
        $('.collection-slider-8items').slick({
            dots: true,
            infinite: true,
            slidesToShow: 8,
            slidesToScroll: 1,
            arrows: true,
            autoplay: true,
            autoplaySpeed: 4000,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 7
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 5
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ]
        });
    } 

    /* 13.12 Products Slider 3 Items */
    if($('.product-slider-3items').length){
        $('.product-slider-3items').slick({
            dots: false,
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            responsive: [
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    } 

    /* 13.13 Products Slider 4 Items */
    if($('.product-slider-4items').length){
        $('.product-slider-4items').slick({
            dots: false,
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    } 

    /* 13.14 Products Slider 5 Items */
    if($('.product-slider-5items').length){
        $('.product-slider-5items').slick({
            dots: false,
            infinite: true,
            slidesToShow: 5,
            slidesToScroll: 1,
            arrows: true,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }

    /* 13.15 Logo Slider 6 Items */
    if($('.logo-slider-6items').length) {
        $('.logo-slider-6items').slick({
            dots: false,
            infinite: true,
            slidesToShow: 6,
            slidesToScroll: 1,
            arrows: true,
            autoplay: true,
            autoplaySpeed: 3000,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    } 

    /* 13.16 Testimonial Slider 1 Items */
    if($('.testimonial-slider-1items').length){
        $('.testimonial-slider-1items').slick({
            dots: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            adaptiveHeight: true
        });
    } 

    /* 13.17 Testimonial Slider 2 Items */
    if($('.testimonial-slider-2items').length){
        $('.testimonial-slider-2items').slick({
            dots: true,
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: true,
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false
                    }
                }
            ]
        });
    } 

    /* 13.18 Testimonial Slider 3 Items */
    if($('.testimonial-slider-3items').length){
        $('.testimonial-slider-3items').slick({
            dots: true,
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 3,
            arrows: false,
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false
                    }
                }
            ]
        });
    } 

    /* 13.19 Blog Slider 3 Items */
    if($('.blog-slider-3items').length){
        $('.blog-slider-3items').slick({
            dots: false,
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    } 

    /* 13.20 Instagram Slider */
    if($('.instagram-slider-5items').length){
        $('.instagram-slider-5items').slick({
            dots: false,
            infinite: true,
            slidesToShow: 5,
            slidesToScroll: 1,
            arrows: true,
            autoplay: true,
            autoplaySpeed: 6000,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    } 

    /* 13.21 Service Slider 4 Items */
    if($('.service-slider-4items').length){
        $('.service-slider-4items').slick({
            dots: false,
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            autoplay: true,
            autoplaySpeed: 4000,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    } 

    /* 13.22 Service Slider 5 Items */
    if($('.service-slider-5items').length){
        $('.service-slider-5items').slick({
            dots: true,
            infinite: true,
            slidesToShow: 5,
            slidesToScroll: 1,
            arrows: true,
            autoplay: true,
            autoplaySpeed: 4000,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    } 

    /* 13.23 Grid Multiple Product */
    if($('.multiple-product').length){ 
        $('.multiple-product').slick({
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true
        });
    } 

    /*-----------------------------------
     Slider Refresh
     -------------------------------------*/
    function slider_refresh() {
        $(".nav-tabs .nav-item").on('click', function() {
            $('.tabs-listing .slick-slider').slick('refresh');
        });
    }
    slider_refresh();
 
    /*-----------------------------------
     14. Infinite Scroll js
     -------------------------------------*/
    function product_three_loadmore() {
        $(".product-three-loadmore .item").slice(0, 12).show();
        $(".loadMore3").on('click', function(e) {
            e.preventDefault();
            $(".product-three-loadmore .item:hidden").slice(0, 3).slideDown();
            if ($(".product-three-loadmore .item:hidden").length == 0) {
                $(".infiniteload").html('<div class="btn btn-lg loadMore3">No more products</div>');
            }
        });
    }
    product_three_loadmore();

    function product_four_loadmore() {
        $(".product-four-loadmore .item").slice(0, 8).show();
        $(".loadMore4").on('click', function(e) {
            e.preventDefault();
            $(".product-four-loadmore .item:hidden").slice(0, 4).slideDown();
            if ($(".product-four-loadmore .item:hidden").length == 0) {
                $(".infiniteload").html('<div class="btn btn-lg loadMore4">No more products</div>');
            }
        });
    }
    product_four_loadmore();

    function product_listview_loadmore() {
        $(".product-listview-loadmore .item").slice(0, 8).show();
        $(".loadMoreList").on('click', function(e) {
            e.preventDefault();
            $(".product-listview-loadmore .item:hidden").slice(0, 1).slideDown();
            if ($(".product-listview-loadmore .item:hidden").length == 0) {
                $(".infiniteload").html('<div class="btn btn-lg loadMoreList">No more products</div>');
            }
        });
    }
    product_listview_loadmore();

    function blog_listview_loadmore() {
        $(".blog-listview-loadmore .blog-article").slice(0, 3).show();
        $(".loadMore1").on('click', function(e) {
            e.preventDefault();
            $(".blog-listview-loadmore .blog-article:hidden").slice(0, 1).slideDown();
            if ($(".blog-listview-loadmore .blog-article:hidden").length == 0) {
                $(".infiniteload").html('<div class="btn btn-lg loadMore1">No more Blog post</div>');
            }
        });
    }
    blog_listview_loadmore();


    /*----------------------------------
     15. Tooltip
     -----------------------------------*/
    function tooltip() {
    }
    tooltip();


    /*-----------------------------------
     16. Sidebar Categories Level links
     -------------------------------------*/
    function categories_level() {
        $(".sidebar-categories .sub-level a").on("click", function() {
            $(this).toggleClass('active');
            $(this).next(".sublinks").slideToggle("slow");
        });
    }
    categories_level();

    $(".filter-widget .widget-title").on("click", function() {
        $(this).next().slideToggle('300');
        $(this).toggleClass("active");
    });

    $('.dropdown-menu').on('click', function(e) {
        if ($(this).hasClass('filterDD')) {
            e.stopPropagation();
        }
    });
 
    /*-----------------------------------
     18. Shop List-grid js
     -------------------------------------*/
    function grid_options() {
        $(".grid-options .mode-list").on("click", function() {
            $(".product-options").removeClass("row-cols-xl-5 row-cols-lg-4 row-cols-md-3 row-cols-sm-3 row-cols-2 list-style").addClass("list-style");
        });
        $('.grid-2').on('click', function() {
            $(".product-options").removeClass("row-cols-xl-5 row-cols-lg-4 row-cols-md-3 row-cols-sm-3 row-cols-2 list-style").addClass("row-cols-2");
        });
        $('.grid-3').on('click', function() {
            $(".product-options").removeClass("row-cols-xl-5 row-cols-lg-4 row-cols-md-3 row-cols-sm-3 row-cols-2 list-style").addClass("row-cols-md-3 row-cols-sm-3 row-cols-2");
        });
        $('.grid-4').on('click', function() {
            $(".product-options").removeClass("row-cols-xl-5 row-cols-lg-4 row-cols-md-3 row-cols-sm-3 row-cols-2 list-style").addClass("row-cols-lg-4 row-cols-md-3 row-cols-sm-3 row-cols-2");
        });
        $('.grid-5').on('click', function() {
            $(".product-options").removeClass("row-cols-xl-5 row-cols-lg-4 row-cols-md-3 row-cols-sm-3 row-cols-2 list-style").addClass("row-cols-xl-5 row-cols-lg-4 row-cols-md-3 row-cols-sm-3 row-cols-2");
        });

        var contentwidth = getWindowWidth();
        if (contentwidth < 1199) {
            $(".grid-options .grid-4").addClass("active");
        }
        if (contentwidth < 991) {
            $(".grid-options .grid-3").addClass("active");
        }
        if (contentwidth < 767) {
            $(".grid-options .grid-2").addClass("active");
        }

        $(".grid-options .icon-mode").click(function() {
            $(".grid-options .icon-mode.active").removeClass("active");
            $(this).addClass("active");
        });
    }
    grid_options();


    /* --------------------------------------
     19. Image swap on click
     -------------------------------------- */
    function product_image_swap() {
        $(".product-box .swatchLbl img").click(function() {
            parentClass = $(this).parent().closest(".product-box");
            ChldImg = parentClass.find(".product-image img");
            ImageSrcValue = $(this).attr("src");
            ChldImg.attr("src", $(this).attr("src").replace());
            $(this).parent().siblings(".active").removeClass("active");
            $(this).parent().addClass("active");
        });
    }
    product_image_swap();


    /* --------------------------------------
     20. Image to background js
     -------------------------------------- */
    $(".bg-top").parent().addClass('b-top');
    $(".bg-bottom").parent().addClass('b-bottom');
    $(".bg-center").parent().addClass('b-center');
    $(".bg-left").parent().addClass('b-left');
    $(".bg-right").parent().addClass('b-right');
    $(".bg_size_content").parent().addClass('b_size_content');
    $(".bg-img").parent().addClass('bg-size');
    $(".bg-img.blur-up").parent().addClass('');
    function getBgImageSrc(el) {
        var image = el.get(0),
                src = image ? (image.currentSrc || image.getAttribute('src')) : el.attr('src');

        if (src && src.indexOf('data:image/') !== 0) {
            return src;
        }

        src = el.attr('data-src');
        if (src && src.indexOf('data:image/') !== 0) {
            return src;
        }

        return '';
    }

    function applyBgImage(el) {
        var src = getBgImageSrc(el),
                parent = el.parent();

        if (!src) return false;

        parent.css({
            'background-image': 'url(' + src + ')',
            'background-size': 'cover',
            'background-position': 'center',
            'background-repeat': 'no-repeat'
        });
        el.hide();
        return true;
    }

    document.addEventListener('lazyloaded', function(event) {
        var target = $(event.target);

        if (target.hasClass('bg-img')) {
            applyBgImage(target);
        }
    });

    jQuery('.bg-img').each(function() {
        var el = $(this);

        applyBgImage(el);
    });


     

    // Resize Function 
    var resizeTimer;
    $(window).resize(function(e) {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            $(window).trigger('delayed-resize', e);
        }, 250);
    });
  
    /* Blog Pages Sidebar Widget +/- */
    function blog_sidebar_dropdown() {
        $(".blog-sidebar .widget-title").on("click", function() {
            if (getWindowWidth() < 991) {
                $(this).next().slideToggle('300');
                $(this).toggleClass("active");
            }
        });
    }
    blog_sidebar_dropdown();

    $(window).on("load resize", function(e) {
        if (getWindowWidth() > 991) {
            $(".blog-sidebar .widget-content").show();
        } else {
            $(".blog-sidebar .widget-content").hide();
        }
    });


    /*-----------------------------------------
     22. Masonry Grid
     -----------------------------------------*/
    if ($.fn.masonry && $.fn.imagesLoaded && $('.grid-masonary').length) {
        var $grid = $('.grid-masonary').masonry({
            itemSelector: '.masonary-item',
            percentPosition: true,
            columnWidth: '.grid-sizer'
        });

        $grid.imagesLoaded().progress(function() {
            $grid.masonry();
        });
    }


    function positionLookbookPreview(button, preview) {
        var products = button.closest('.products')[0].getBoundingClientRect();
        var background = button.closest('.bg-size')[0].getBoundingClientRect();
        var bottomLimit = Math.min(window.innerHeight, background.bottom);
        var opensAbove = products.bottom + 10 + preview.outerHeight() > bottomLimit;
        preview.toggleClass('top', opensAbove).toggleClass('bottom', !opensAbove);
    }

    $('.products-lookbook-section .btn-shop').on('click', function() {
        var button = $(this);
        var preview = button.siblings('.lookbook-preview');
        var wasOpen = preview.hasClass('active');
        $('.products-lookbook-section .btn-shop').removeClass('active').attr('aria-expanded', 'false');
        $('.products-lookbook-section .lookbook-preview').removeClass('active');
        $('.products-lookbook-section .lookbook-item').removeClass('is-open');
        if (wasOpen) return;
        button.addClass('active').attr('aria-expanded', 'true');
        button.closest('.lookbook-item').addClass('is-open');
        preview.addClass('active');
        positionLookbookPreview(button, preview);
    });

    $(document).on('click', function(event) {
        if ($(event.target).closest('.products-lookbook-section .lookbook-item.is-open').length) return;
        $('.products-lookbook-section .lookbook-preview').removeClass('active');
        $('.products-lookbook-section .lookbook-item').removeClass('is-open');
        $('.products-lookbook-section .btn-shop').removeClass('active').attr('aria-expanded', 'false');
    });

    $('.products-lookbook-section .lookbook-preview img').on('load', function() {
        var preview = $(this).closest('.lookbook-preview');
        if (preview.hasClass('active')) positionLookbookPreview(preview.siblings('.btn-shop'), preview);
    });

    $(window).on('resize', function() {
        $('.products-lookbook-section .btn-shop.active').each(function() {
            positionLookbookPreview($(this), $(this).siblings('.lookbook-preview'));
        });
    });

    /*-------------------------------
     23. Scroll Top
     ---------------------------------*/
    function scroll_top() {
        $("#site-scroll").on("click", function() {
            $("html, body").animate({scrollTop: 0}, 1000);
            return false;
        });
    }
    scroll_top();
    (function() {
        var siteScroll = $("#site-scroll"),
                siteScrollVisible = null,
                ticking = false;

        function update() {
            var nextVisible = getScrollTop() > 300;

            if (nextVisible === siteScrollVisible) {
                return;
            }

            siteScrollVisible = nextVisible;
            siteScroll.stop(true, true)[nextVisible ? "fadeIn" : "fadeOut"]();
        }

        $(window).on("scroll", function() {
            if (ticking) {
                return;
            }

            ticking = true;
            requestFrame(function() {
                ticking = false;
                update();
            });
        });

        update();
    })();


    /*-----------------------------------
     24. Tabs With Accordian Responsive
     -------------------------------------*/
    $(".tab_content").hide();
    $(".tab_content:first").show();
    /* if in tab mode */
    $("ul.tabs li").on('click', function() {
        $(".tab_content").hide();
        var activeTab = $(this).attr("rel");
        $("#" + activeTab).fadeIn();

        $("ul.tabs li").removeClass("active");
        $(this).addClass("active");

        $(".tab_drawer_heading").removeClass("d_active");
        $(".tab_drawer_heading[rel^='" + activeTab + "']").addClass("d_active");

        $('.productSlider').slick('refresh');
        $('.productSlider-style2').slick('refresh');
    });
    /* if in drawer mode */
    $(".tab_drawer_heading").on('click', function() {
        $(".tab_content").hide();
        var d_activeTab = $(this).attr("rel");
        $("#" + d_activeTab).fadeIn();

        $(".tab_drawer_heading").removeClass("d_active");
        $(this).addClass("d_active");

        $("ul.tabs li").removeClass("d_active");
        $("ul.tabs li[rel^='" + d_activeTab + "']").addClass("d_active");

        $('.productSlider').slick('refresh');
        $('.productSlider-style2').slick('refresh');
    });
    $('ul.tabs li').last().addClass("tab_last");


    /*----------------------------------
     25. Product Details Page
     ------------------------------------*/
    /* Horizontal Thumb Slider */
    function product_thumb1() {
        $('.product-thumb-horizontal').slick({
            infinite: true,
            slidesToShow: 5,
            stageMargin: 5,
            slidesToScroll: 1,
            responsive: [
                { breakpoint: 576, settings: { slidesToShow: 4 } },
                { breakpoint: 360, settings: { slidesToShow: 3 } }
            ]
        });
    }
    product_thumb1();

    /* Vertical Thumb Slider */
    function product_thumb() {
        $('.product-thumb-vertical').slick({
            infinite: true,
            slidesToShow: 5,
            vertical: true,
            verticalSwiping: true,
            centerPadding: '0',
            draggable: true,
            slidesToScroll: 1
        });
    }
    product_thumb();


    /*----------------------------------
     26. Visitor Fake Message
     ------------------------------------*/
    var userLimit = $(".userViewMsg").attr('data-user'),
            userTime = $(".userViewMsg").attr('data-time');
    $(".uersView").text(Math.floor((Math.random() * userLimit)));
    setInterval(function() {
        $(".uersView").text(Math.floor((Math.random() * userLimit)));
    }, userTime);


    
    $(".product-detail .tab-content").hide();
    $(".product-detail .tab-content:first").show();
    $(".product-detail .product-tabs li").on('click', function() {
        $(".tab-content").hide();
        var activeTab = $(this).attr("rel");
        $("#" + activeTab).fadeIn();

        $(".product-detail .product-tabs li").removeClass("active");
        $(this).addClass("active");

        $(this).fadeIn();
        if (getWindowWidth() < 767) {
            var tabposition = $(this).offset();
            $("html, body").animate({scrollTop: tabposition.top - 70}, 700);
        }
    });
    $('.product-detail .product-tabs li:first-child').addClass("active");
    $('.product-detail .tab-container h3:first-child + .tab-content').show();
   
    function initStarRating() {
        const $rating = $('.review-rating');
        if (!$rating.length) return; 
        $rating.on('mouseenter', 'label', function () {
            const val = parseInt($(this).find('input').val());
            $rating.find('label').each(function () {
                const starVal = parseInt($(this).find('input').val());
                const $icon = $(this).find('i');
                if (starVal <= val) {
                    $(this).addClass('hover');
                    $icon.removeClass('anm-star-o').addClass('anm-star');
                } else {
                    $(this).removeClass('hover');
                    $icon.removeClass('anm-star').addClass('anm-star-o');
                }
            });
        });
        $rating.on('mouseleave', function () {
            $rating.find('label').removeClass('hover');
            updateSelected();
        });
        $rating.on('click', 'input[type=radio]', function () {
            updateSelected();
        });
        function updateSelected() {
            const selected = $rating.find('input[type=radio]:checked').val();
            $rating.find('label').each(function () {
                const starVal = parseInt($(this).find('input').val());
                const $icon = $(this).find('i');
                if (starVal <= selected) {
                    $(this).addClass('selected');
                    $icon.removeClass('anm-star-o').addClass('anm-star');
                } else {
                    $(this).removeClass('selected');
                    $icon.removeClass('anm-star').addClass('anm-star-o');
                }
            });
        }
        updateSelected();
    }

    initStarRating();

    /* if in drawer mode */
    $(".acor-ttl").on("click", function() {
        $(".tab-content").hide();
        var activeTab = $(this).attr("rel");
        $("#" + activeTab).fadeIn();

        $(".acor-ttl").removeClass("active");
        $(this).addClass("active");
        if (getWindowWidth() < 767) {
            var tabposition = $(this).offset();
            $("html, body").animate({scrollTop: tabposition.top}, 700);
        }
    });

    /* Below 767 Accordian style */
    $(".tabs-ac-style").on("click", function() {
        $(".tab-content").hide();
        var activeTab = $(this).attr("rel");
        $("#" + activeTab).fadeIn();

        $(".tabs-ac-style").removeClass("active");
        $(this).addClass("active");

        $(this).fadeIn();
        if (getWindowWidth() < 767) {
            var tabposition = $(this).offset();
            $("html, body").animate({scrollTop: tabposition.top}, 700);
        }
    });


    /*----------------------------
     28. Sticky Header and Product Sticky Bottom Cart
     ------------------------------ */
    function sticky_cart() {
        var stickyCart = $(".stickyCart");
        if (stickyCart.length) {
            var productBody = $("body.template-product"),
                    visible = null,
                    ticking = false;

            function updateStickyCart() {
                var nextVisible = getScrollTop() > 600;

                if (nextVisible === visible) {
                    return;
                }

                visible = nextVisible;
                productBody.css("padding-bottom", nextVisible ? "70px" : "0");
                stickyCart.stop(true, true)[nextVisible ? "slideDown" : "slideUp"]();
            }

            $(window).on("scroll", function() {
                if (ticking) {
                    return;
                }

                ticking = true;
                requestFrame(function() {
                    ticking = false;
                    updateStickyCart();
                });
            });

            updateStickyCart();
        }
        $(".stickyOptions .selectedOpt").on("click", function() {
            $(".stickyOptions ul").slideToggle("fast");
        }),
                $(".stickyOptions .vrOpt").on("click", function(e) {
            var t = $(this).attr("data-val"),
                    s = $(this).attr("data-no"),
                    a = $(this).text();
            $(".selectedOpt").text(a), $(".stickyCart .selectbox").val(t).trigger("change"), $(".stickyOptions ul").slideUp("fast"), this.productvariants = JSON.parse(document.getElementById("ProductJson-" + i).innerHTML), $(".stickyCart .product-featured-img").attr("src", this.productvariants.variants[s].featured_image.src.replace(/(\.[^\.]*$|$)/, "_60x60$&"));
        });
    }
    sticky_cart();

    /*----------------------------
     29. Checkout Style2 Tabs
     ------------------------------ */
 

    $('.btnNext').click(function() {
        const nextTabLinkEl = $('.nav-tabs .active').closest('li').next('li').find('a')[0];
        if (!nextTabLinkEl) {
            return;
        }
        withBootstrap(function() {
            const nextTab = new bootstrap.Tab(nextTabLinkEl);
            nextTab.show();
        });
    });

    $('.btnPrevious').click(function() {
        const prevTabLinkEl = $('.nav-tabs .active').closest('li').prev('li').find('a')[0];
        if (!prevTabLinkEl) {
            return;
        }
        withBootstrap(function() {
            const prevTab = new bootstrap.Tab(prevTabLinkEl);
            prevTab.show();
        });
    });
                    
    function product_zoom() {
        $(".zoompro").elevateZoom({
            gallery: "gallery",
            galleryActiveClass: "active",
            zoomWindowWidth: 300,
            zoomWindowHeight: 100,
            scrollZoom: false,
            zoomType: "inner",
            cursor: "crosshair"
        });
    }
    //product_zoom();
    
    $(document).on('click', '#gallery a[data-image]', function(e) {
        e.preventDefault();
        var $this = $(this);
        var image = $this.data('image');
        var zoomImage = $this.data('zoom-image');
        $('#zoompro').attr('src', image).attr('data-zoom-image', zoomImage);
        $('#gallery a[data-image]').removeClass('active');
        $('#gallery a[data-index="' + $this.attr('data-index') + '"]').addClass('active');
    });

    $(function () {
        if ($('.lightboximages').length) {
            var $pswp = $('.pswp')[0];
            function getItems() {
                return $('.lightboximages a').map(function () {
                    var size = String($(this).data('size') || '0x0').split('x');
                    return {
                        src: this.href,
                        w: parseInt(size[0], 10) || 0,
                        h: parseInt(size[1], 10) || 0
                    };
                }).get();
            }
            var items = getItems();
            var total = items.length;
            items.forEach(function (it) { var i = new Image(); i.src = it.src; });
            $('.prlightbox').on('click', function (e) {
                e.preventDefault();
                if (!window.PhotoSwipe || !window.PhotoSwipeUI_Default) {
                    return;
                }

                var $gallery = $('#gallery');
                var $curSlide = $gallery.find('a[data-image].active').first();
                var idx = parseInt($curSlide.attr('data-index'), 10);
                if (isNaN(idx)) {
                    var raw = parseInt($curSlide.attr('data-slick-index'), 10);
                    if (!isNaN(raw) && total > 0) {
                        idx = ((raw % total) + total) % total; 
                    } else {
                        idx = 0;
                    }
                }
                if (idx < 0 || idx >= total) idx = 0;
                var lightBox = new PhotoSwipe($pswp, PhotoSwipeUI_Default, items, {
                    index: idx,
                    bgOpacity: 0.7,
                    showHideOpacity: true
                });
                lightBox.init();
            });
        }
    });

    if ($.fn.imagesLoaded && $.fn.isotope && $('.masonary-filter').length) {
        var $portfolioGrid = $('.masonary-filter').imagesLoaded(function() {
            $portfolioGrid.isotope({
                itemSelector: '.portfolio-masonary',
                percentPosition: true,
                gutter: 0,
                masonry: {
                    columnWidth: '.grid-sizer'
                }
            });
        });

        $('.portfolio-nav a').click(function() {
            $('.portfolio-nav a').removeClass('active');
            $(this).addClass('active');
            var selector = $(this).attr('data-filter');
            $('.masonary-filter').isotope({
                filter: selector
            });
            return false;
        });
    }

    window.onload = init;
    function init() {
        var product; 
        $('.nav_bar_previous').bind('click', function(e) {
            product.previous();
        });
        $('.nav_bar_next').bind('click', function(e) {
            product.next();
        });
        $('.nav_bar_play').bind('click', function(e) {
            product.play();
        });
    }
     
    });
})(jQuery);
